/* eslint-disable quotes */
import escape from 'lodash-es/escape';

export default (product) => {
  // Use first variant - handle both Shopify and Constructor API variant structures
  const firstVariant = product.variants[0];
  const active_style =
    firstVariant?.barcode ||
    firstVariant?.Barcode ||
    firstVariant?.data?.barcode ||
    firstVariant?.imgs?.split(`products/`)[1]?.split(`_`)[0] ||
    '';
  const admind_product = {
    id: product.pid ? product.pid : product.id,
    style: active_style,
    // category: ,
    subcategory: escape(product.product_type),
    name: escape(product.title.replace(/((CLEARANCE)|(PLACEHOLDER))( - )/, '')),
    price: product.price,
    originalPrice: product.price_compare === `0.00` ? product.price : product.price_compare,
    newArrival: product.tags.includes(`New Arrival`),
    isMarkedDown: Number(product.price) < Number(product.price_compare),
    hasReviews: product.reviewsCount > 0,
    reviewCount: product.reviewsCount ? product.reviewsCount : 0,
    reviewAverage: product.review ? product.review / 20 : 0,
    showsQuadpay: !!document.querySelector('[data-klarna-visible]'),
    almostGone: false,
    position: product.position ? product.position : 1,
  };

  const dataLayer = window.dataLayer || [];

  // Now, we will trigger this event even on Homepage and PDP
  // This won't be exclusive to Collection pages. The purpose is populate 'item_list_name' more in GA4
  dataLayer.push({
    event: `productClick`,
    ecommerce: {
      click: {
        products: [admind_product],
        actionField: {
          list: product.clickList || `recommendations_${product.podId}`,
        },
        eventCallback: () => {
          document.location = product.product_url;
        },
        eventTimeout: 2000,
      },
    },
  });
};
